import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { IMainLayoutConfig } from '../../../../shared/models/main-layout.config';
import {
  ApiService,
  AuthService,
  EventsService,
  FundraiserService,
  StorageService,
  UtilService,
  VariablesService,
  SignupService,
  TickrService,
  CookieService,
  VwoService
} from '../../../../shared/services';          
@Component({
  selector: 'app-common-header',
  templateUrl: './common-header.component.html',
  styleUrls: ['./common-header.component.scss'],
})
export class CommonHeaderComponent implements OnInit, OnChanges, OnDestroy {
  selected = 'option1';
  selectedCurrency;
  isLoggedIn = null;
  userData;
  isMobile: any;
  isIos: any;
  isLoginPopUpOpen = false;
  userImage: string;
  isSearchBoxVisible = false;
  currencySymbol;
  searchQuery;
  customLogoUrl;
  customLogoLink = '';
  showUserIcon = true;
  @Input() public config: IMainLayoutConfig;
  @Output() public logoClickEmit = new EventEmitter();
  countries: any;
  currency;
  logoUrlDark: any;
  logoUrlLight: any;
  isDynamicLogo = false;
  @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;
  public environment = environment;
  hasDonations = false;
  subs = [];
  lastUrlName;
  languages = {
    'en': 'English',
    'hi': 'Hindi',
    'ta': 'Tamil',
    'te': 'Telugu',
    'ar': 'Arabic',
    'ur': 'Urdu'
  };
  availableLangs = [];
  loadLoginPopup = false;
  isTempUser;
  isAnyActiveSip;
  isMemorialSip;
  hideNudge;
  isAppUser;
  exist_sip;
  isDrawerOpened = false;
  initials = '';
  livesImpactedList = [
    { id:1, label: 'Donations done', value: '02' },
    { id:2, label: 'Lives Impacted', value: '04' },
    { id:3, label: 'Do good days', value: '22' }
  ]
  menuList = [
    {id: 1, label: 'My Donations', iconName: 'my-donations', isSipRedirect: true, redirectTo: 'mydonations'},
    {id: 2, label: 'My Monthly SIP\'s', iconName: 'monthly-sip', isSipRedirect: false, redirectTo: 'new/sip'},
    {id: 3, label: 'Preference', iconName: 'preference', isSipRedirect: true, redirectTo: 'preferences'},
    {id: 4, label: 'Refer & Earn', iconName: 'refer-and-earn', isSipRedirect: true, redirectTo: 'referral'},
    {id: 5, label: 'FAQ\'s', iconName: 'support', isSipRedirect: false, redirectTo: ''},
    {id: 6, label: 'Logout', iconName: 'preference', isSipRedirect: false, redirectTo: ''},
  ]
  isHomev2 = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private storageService: StorageService,
    public utilService: UtilService,
    public authService: AuthService,
    private apiService: ApiService,
    public variablesService: VariablesService,
    private cookieService: CookieService,
    private fundraiserService: FundraiserService,
    public eventService: EventsService,
    private dialog: MatDialog,
    private signupService: SignupService,
    private actRoute: ActivatedRoute,
    private router: Router,
    private tickrService: TickrService,
    public vwo: VwoService

  ) {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          const urlWithoutParams = this.router.url.split('?')[0];
          this.lastUrlName = urlWithoutParams.split('/')[urlWithoutParams.split('/').length - 1];
        }
      });
  }

  sipRedirect(route:string): string {
    if (this.utilService.isBrowser) {
      const redirectUrl = encodeURIComponent(window.location.href);
      return `${environment.sipretention_domain}/${route}?redirect_url=${redirectUrl}`;
    }
    return '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.config && changes.config.currentValue) {
      for (const key of Object.keys(this.config)) {
        if (this.config[key] === undefined) {
          this.config[key] = false;
        }
      }
    }
  }

  ngOnInit() {
    this.countries = this.utilService.currencies;
    this.logoUrlDark = this.utilService.logoUrlDark;
    this.logoUrlLight = this.utilService.logoUrlLight;
    this.isMobile = this.utilService.isMobile();
    this.isIos = this.utilService.isIOSDevice();
    const urlWithoutParams = this.router.url.split('?')[0];
    this.lastUrlName = urlWithoutParams.split('/')[urlWithoutParams.split('/').length - 1];
    // checks for @ in url for temp user login
    this.subs.push(this.actRoute.queryParams.subscribe(queryParams => {
      if (Object.keys(queryParams).length > 0 && Object.values(queryParams).some(val => val.includes('@')) && !this.isLoggedIn) {
        this.isTempUser = true;
      }
    }));
    // open drawer from dock
    this.subs.push(this.variablesService.openDrawerFromDockState.asObservable().subscribe(val => {
      if (this.isMobile && typeof val === 'string' && val === 'open') {
        this.sidenav.toggle();
        this.isDrawerOpened = true;
        this.variablesService.openDrawerFromDockState.next(false);
      }
    }));
    this.subs.push(this.variablesService.homeV2.subscribe(val => {
      this.isHomev2 = val;
    }));
    this.subs.push(this.variablesService.drawerState.asObservable().subscribe(val => {
      this.isDrawerOpened = val;
    }));
    if (this.utilService.isBrowser) {
      this.variablesService.theme.subscribe(res => {
        if (res.primary_color) {
          this.setTheme(res.primary_color, res.font_color);
          this.utilService.doc.body.classList.add('custom-theme');
        } else if (!res.primary_color) {
          this.setTheme('#01bfbd', res.font_color);
          this.utilService.doc.body.classList.remove('custom-theme');
        }
        if (res.logo) {
          this.isDynamicLogo = true;
          this.customLogo(res.logo, res.access_url);
        } else if (!res.logo) {
          this.isDynamicLogo = false;
        }
      });
    }
    this.checkUserLogin();
    this.setTranslator();
    this.getCurrency();
    if (this.userData) {
      this.initials = this.getInitials(this.userData);
    }
    this.isAppUser = this.cookieService.getCookie('platform');
  }


  getInitials(userData) {
    if (!userData || !userData.full_name) return '';
  
    const nameParts = userData.full_name.split(' ');
    if (nameParts.length === 0) return '';
  
    const initials = nameParts.map(part => part[0]).join('').toUpperCase();
    return initials.slice(0, 2);
  }

  onMenuItemClicked() {
    this.variablesService.drawerState.next(false);
  }

  redirectionLogic(item) {
    if (this.utilService.isBrowser) {
      let a = document.createElement('a');
      // close drawer
      this.variablesService.drawerState.next(false);
      this.isDrawerOpened = false;
      if (this.isMobile) {
        this.sidenav.toggle();
      }
      if (item.isSipRedirect) {
        const redirectLink = this.sipRedirect(item.redirectTo);
        a.href = redirectLink;
        a.click();
      } else if (item.iconName === 'support') {
        a.href = 'https://customerhappiness.ketto.org/portal/en/kb';
        a.click();
      } else if (item.label === 'Logout') {
        this.logout();
        this.variablesService.openDrawerFromDockState.next(false);
        this.variablesService.homeV2.next(false);
        // removing dock on logout
        this.variablesService.mainLayoutConfig.next({
          showHeader: true,
          showFooter: true,
          showMenus: true,
          showProfile: true,
          showSearch: true,
          logoNavigate: true,
          animateHeader: true,
          headerClass: 'homepage-header white-bg',
          headerTopSticky: true,
          showCurrency: false,
          zendesk: true,
          showFooterSEO: true,
          enableDock: false
        });
      } else {
        this.router.navigate([item.redirectTo]);
      }
    } 
  }

  checkSipType() {
    this.exist_sip = Object.keys(this.userData?.listsubscriptions || {});
    const sip_status_flag = this.utilService.checkForActiveSip(this.userData?.listsubscriptions);
    if (sip_status_flag.toString().match('1|2')) {
      this.isAnyActiveSip = true;
      if (this.isHomev2) {
        this.menuList.map(item => {
          if (item && item.iconName === 'monthly-sip') {
            item.redirectTo = 'mysip';
            item.isSipRedirect = true;
          }
        })
      }
    } else if (this.userData?.listsubscriptions?.memorial?.status_flag.toString().match('1|2')) {
      this.isMemorialSip = true;
    }
  }

  getCurrency() {
    this.utilService.currency.subscribe((res) => {
      this.currency = res;
      if (this.currency) {
        this.currencySymbol = this.utilService.getCurrencyObj(this.currency).symbol;
      }
    });
  }

  /**Set currencySymbol from menu */
  setCurrencyFromMenu(item, name?) {
    if (name === 'select') {
      item = this.countries[item.target.selectedIndex];
    }
    this.currencySymbol = item.symbol;
    this.variablesService.currencyObj = item;
    this.utilService.setCurrency(item.currency);
    this.tickrService.stopTickr = true;
    this.apiService.setCurrency(item.currency).subscribe(_ => _);
  }

  setTranslator() {
    this.variablesService.translateLangArray.subscribe(res => {
      if (res) {
        this.availableLangs = [{ key: 'en', value: 'English' }];
        res.forEach(langCode => {
          if (langCode) {
            this.availableLangs.push({ key: langCode, value: this.languages[langCode] });
          }
        });
      }
    });
  }

  setTranslatorLang(lang) {
    this.storageService.addSessionData('language', lang)
    this.router.navigate([], { queryParams: { lang: lang }, queryParamsHandling: 'merge' });
    this.variablesService.tranlatedLanguage = lang;
    this.variablesService.languageObs.next(lang);
  }

  customLogo(url: string, access_url: string) {
    this.customLogoUrl = url;
    if (access_url) {
      this.customLogoLink = `https://${access_url}`;
    }
  }

  toggleDrawer() {
    this.isDrawerOpened = !this.isDrawerOpened;
    this.variablesService.drawerState.next(this.isDrawerOpened);
  }

  setTheme(primary_color, font_color) {
    this.document.documentElement.style.setProperty('--primary-color', primary_color);
    const code = this.utilService.hexToRgb(primary_color);
    if (code) {
      this.document.documentElement.style.setProperty('--primary-color-rgb', `${code.r}, ${code.g}, ${code.b}`);
    }
  }

  /**logo click listner */
  onLogoClick(event) {
    event.preventDefault();
    if (this.config.logoNavigate) {
      this.utilService.router.navigate(['/']);
    } else {
      this.logoClickEmit.emit(true);
    }
  }
  onCustomLogoClick(event) {
    event.preventDefault();
    this.utilService.nativeNavigation(this.customLogoLink, true);
  }
  onLoggedInUser() {
    this.variablesService.userData.subscribe({
      next: (res) => {
        this.userData = res;
        if (res && res.donor && res.donor.length > 0) {
          this.hasDonations = true;
        }
        if (res) {
          this.isLoggedIn = true;
          this.isTempUser = true;
          this.checkSipType();
        }
        this.showUserIcon = res && res.avtar && res.avtar.cdn_path ? false : true;
      }
    });
  }

  showSearchBox() {
    this.isSearchBoxVisible = true;
    this.eventService.sendSystemEvent({
      eventName: 'search_clicked'
    }).subscribe(_ => _);
    this.variablesService.drawerState.next(false);
  }

  logout() {
    this.authService.sessionLogout().subscribe({next: (res) => this.logoutUser(), error: () => this.logoutUser()});
  }

  logoutUser() {
    this.storageService.delete('user');
    this.storageService.delete('userdata');
    this.storageService.delete('abandonedCart');
    this.storageService.delete('abandonedCartOtd');
    this.storageService.deleteFromSession('showBanner');
    this.storageService.deleteFromSession('sipUserRedirect');
    this.cookieService.deleteCookie('u_auth', '.ketto.org');
    this.utilService.isToken = false;
    this.utilService.isLoggedIn.next(false);
    this.variablesService.userData.next(null);
    this.isLoggedIn = false;
    this.isTempUser = false;
    this.hasDonations = false;
    this.router.navigateByUrl(this.router.url);
  }

  /**check user logged in status */
  checkUserLogin() {
    this.onLoggedInUser();
    this.utilService.isLoggedIn.subscribe((res) => {
      this.isLoggedIn = res;
      if (res) {
        this.isTempUser = res;
      }
    });
  }

  /**Get the header for  */
  getHeader() {
    const domainName = this.utilService.domain_details.domain_name;
    if (this.utilService.isMicroSite()) {
      const qParam = '?with=themeInfo;navmenu;candonatedirect;basicInfo;logo;avtar';
      this.fundraiserService.getHeader(domainName, qParam).subscribe((res: any) => {
        this.setThemColor(res.data.theme_info);
        this.setLogo(res.data.avtar);
      });
      return false;
    } else {
      this.logoUrlDark = this.utilService.logoUrlDark;
      this.logoUrlLight = this.utilService.logoUrlLight;
    }
  }
  /**Set Theme color */
  setThemColor(theme) {
    if (theme && theme.length) {
      const html = this.document.getElementsByTagName('html')[0];
      html.style.cssText = `--primary-color: ${theme.info_1}`;
    }
  }
  /**Set Logo */
  setLogo(avtar) {
    if (avtar && avtar.cdn_path) {
      this.logoUrlDark = avtar.cdn_path;
    }
  }
  /*Event for start a fundraiser banner button */
  pushHeaderButton(url, event) {
    this.eventService.userGTMEvents({
      event: 'start_fundraiser',
      event_category: 'cta',
      event_action: 'start a fundraiser',
      event_label: `${event.target.innerText}|${window.location.href}`
    });
    const payload = {
      eventName: 'start_a_campaign_initiated',
      event_type: 'campaign',
      page_name: this.variablesService.pageName || 'home',
      referrer_page: this.document.referrer,
      info_1: 'type',
      info_2: 'header_1'
    };
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);
    const full_url = `${this.utilService.domain_details.domain_url}/${url}`;
    this.storageService.checkFromSession('sac-initiated', payload);
    this.variablesService.loginType = 'signup';
    this.variablesService.drawerState.next(false);
    this.signupService.startFR(full_url);
    // this.utilService.nativeNavigation(full_url);
  }

  /*View my impact button tracking */
  sendSystemEvent() {
    const payload = {
      eventName: 'view_impact',
      event_type: 'view_impact',
      page_name: this.variablesService.pageName || 'home',
      referrer_page: this.document.referrer,
      info_1: 'position',
      info_2: '39',
      info_3: 'impact'
    };
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);
  }

  openLoginPopup(loginTemp) {
    this.loadLoginPopup = true;
    const dialogRef = this.dialog.open(loginTemp, {
      'maxWidth': '100vw',
      width: '730px',
      autoFocus: false,
      panelClass: ['login-popup'],
      data: {
        activeScreen: this.actRoute.snapshot.queryParams['as'] === 'si' ? 'si' : 'otp'
      }
    });
    dialogRef.afterOpened().subscribe(() => this.isLoginPopUpOpen = true);
    dialogRef.afterClosed().subscribe(() => this.isLoginPopUpOpen = false);
    this.signupService.sendLoginSystemEvents('Homepage signin clicked');
  }

  /**Close the search bar, the value is emitted from search bar component */
  closeSearchBarHandler = (_e) => {
    if (_e) {
      this.isSearchBoxVisible = false;
      if (this.isMobile) {
        this.sidenav.close();
      }
    }
  }
  /**The search query of the user */
  searchedQuery(_e) {
    this.searchQuery = _e;
  }

  startFrFor(cause) {
    this.eventService.userGTMEvents({
      event: 'start_fundraiser',
      event_category: 'cta',
      event_action: 'start a fundraiser',
      event_label: window.location.href
    });
    const payload = {
      eventName: 'start_a_campaign_initiated',
      event_type: 'campaign',
      page_name: this.variablesService.pageName || 'home',
      referrer_page: this.document.referrer,
      info_1: 'type',
      info_2: 'header_2'
    };
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);
    this.storageService.checkFromSession('sac-initiated', payload);
    if (this.isLoggedIn) {
      const sacPuposeSelected = this.storageService.getFromSession('sac-purpose-selected');
      if (!sacPuposeSelected) {
        const payload2 = {
          eventName: 'cause_selection',
          page_name: this.variablesService.pageName,
          info_1: 'type',
          info_2: 'header_2',
          info_4: cause.value,
          event_type: 'campaign'
        };
        this.eventService.systemEventPush(payload2);
        this.storageService.addSessionData('sac-purpose-selected', { 'purpose': cause.value });
      }
      // tslint:disable-next-line:max-line-length
      const url = cause.value === 'medical' ? this.variablesService.startAFrUrls.medical : this.variablesService.startAFrUrls['non-medical'];
      this.router.navigate([url], { queryParams: { type: cause.value }, queryParamsHandling: 'merge' });
    } else {
      this.router.navigate(['new/crowdfunding'], { queryParams: { type: cause.value }, queryParamsHandling: 'merge' });
    }
    this.variablesService.drawerState.next(false);
  }

  myImpactSystemEvent() {
    const eventPayload = {
      eventName: 'my_impact_clicked',
      event_type: '',
      info_1: 'type 1',
      info_2: '',
      info_3: 'impact',
      page_name: 'impact_portfolio',
      entity_id: ''
    };

    this.eventService.sendSystemEvent(eventPayload).subscribe(_ => _);
  }

  goToMyDonations(template) {
    if (typeof window !== 'undefined') {
      if (this.userData) {
        window.open(this.sipRedirect('mydonations'),'_self')
      } else {
        // this.openLoginPopup();
        this.signupService.openSignUp(template, 'si', () => {
          window.open(this.sipRedirect('mydonations'),'_self')
        });
      }
    }
  }

  /**Check if logged in user is the owner
   * of the campaign then redirect to manage fundraiser
   */
  checkForManageFr() {
    if (this.variablesService.fundraiser && this.userData) {
      if (this.userData.id === this.variablesService.fundraiser.creator_entity_details_id ||
        this.userData.id === this.variablesService.fundraiser.entity_details_id) {
        return true;
      }
    }
  }
  /**Go to the manage fundraiser */
  goToManageFund() {
    this.variablesService.drawerState.next(false);
    const url = environment.manage_domain + '/manage/' + this.variablesService.fundraiser.id + '/dashboard';
    this.utilService.nativeNavigation(url);
  }

  whatsappChat() {
    const payload = {
      eventName: 'wa_chat_with_us',
      event_type: 'campaign',
      info_1: 'type',
      info_2: 4
    };
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);
    // this.eventService.sendSystemEvent(payload).pipe(first()).subscribe(
    //   (data) => {
    //     this.utilService.nativeNavigation('https://api.whatsapp.com/send?phone=91' + this.variablesService.contactUsMobNumber, true);
    //   }
    // );
  }

  appDownloadEvent(for_device) {
    const payload: any = {
      eventName: 'download_app_header',
      page_name: this.variablesService.pageName,
      info_2: for_device
    };
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);
  }

  ngOnDestroy(): void {
    if (this.subs.length > 0) {
      this.subs.forEach(sub => {
        sub.unsubscribe();
      });
    }
  }
}

